import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-input-label',
  standalone: true,
  imports: [MatTooltipModule, NgIf],
  templateUrl: './input-label.component.html',
  styleUrls: ['./input-label.component.scss'],
})
export class InputLabelComponent {
  @Input() isRequired?: boolean;
  @Input() inputId: string = '';
  @Input() noteText: string = '';
  @Input() label!: string;
}
